import { AppDispatch, GetRootState } from 'App';
import { selectAccountSettings } from 'store/selectors/settingsSelectors';
import { ESettingsActions, ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import Settings from 'api/classes/Settings';
import sendGTM from 'utils/sendGTM';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';
import { GTM_CONNECTED_STORE } from 'utils/constants/gtmConstants';

const getSettingsRequest = {
  [ESettingsKey.AccountSettings]: Settings.getAccountSettings,
  [ESettingsKey.PolicySettings]: Settings.getPoliciesSettings,
  [ESettingsKey.StoreSettings]: Settings.getStoreSettings,
  [ESettingsKey.PaymentsSettings]: Settings.getPaymentsSettings,
};

const updateSettingsRequest = {
  [ESettingsKey.AccountSettings]: Settings.updateAccountSettings,
  [ESettingsKey.PolicySettings]: Settings.updatePoliciesSettings,
  [ESettingsKey.StoreSettings]: Settings.updateStoreSettings,
  [ESettingsKey.PaymentsSettings]: Settings.updatePaymentsSettings,
};

export const getSettingsByKeyAction = (key: ESettingsKey) => async(dispatch: AppDispatch) => {
  dispatch({ type: ESettingsActions.GET_SETTINGS, payload: { [key]: { isLoading: true }, key } });
  const { success, data, error }: any = await getSettingsRequest[key]();

  if (success) {
    dispatch({
      type: ESettingsActions.GET_SETTINGS_SUCCESS,
      payload: { [key]: { ...data, isLoading: false, isUpdated: true }, key },
    });
  } else {
    dispatch({ type: ESettingsActions.GET_SETTINGS_FAILURE, payload: { [key]: { isLoading: false }, key } });
    error.errorType !== 'Payment Details not Found' && sendNotification(ENotificationTypes.Error, error.message);
  }
};

const updateSettingsByKeySuccessMessage = {
  [ESettingsKey.AccountSettings]: 'Updated successfully',
  [ESettingsKey.PolicySettings]: 'Updated successfully',
  [ESettingsKey.StoreSettings]: 'Updated successfully',
  [ESettingsKey.PaymentsSettings]: 'Wire Transfer successfully added',
  connectStore: 'Store successfully connected',
};

export const updateSettingsByKeyAction = (payload: any, key: ESettingsKey, isConnectedStore?: boolean) =>
  async(dispatch: AppDispatch, getStore: GetRootState) => {
    const { meta } = selectAccountSettings(getStore());

    if (isConnectedStore) {
      dispatch({ type: ESettingsActions.UPDATE_SETTINGS, payload: { [key]: { isConnectingStore: true }, key } });
    }

    const { success, data, error }: any = await updateSettingsRequest[key](payload);

    if (success) {
      dispatch({ type: ESettingsActions.UPDATE_SETTINGS, payload: { [key]: data, key } });

      sendNotification(
        ENotificationTypes.Success,
        updateSettingsByKeySuccessMessage[isConnectedStore ? 'connectStore' : key],
      );
      if (isConnectedStore) {
        dispatch(getSettingsByKeyAction(ESettingsKey.AccountSettings));
        sendGTM({ ...GTM_CONNECTED_STORE, supplier_store_id: data.id });
      }

      if (key === ESettingsKey.PaymentsSettings && !meta?.isPaymentDetailsConnected) {
        dispatch(getSettingsByKeyAction(ESettingsKey.AccountSettings));
      }
    } else {
      sendNotification(ENotificationTypes.Error, error);
    }

    if (isConnectedStore) {
      dispatch({ type: ESettingsActions.UPDATE_SETTINGS, payload: { [key]: { isConnectingStore: false }, key } });
    }
  };
